import { GDFHotPollyTypes } from '../../../../gdf/type';

export default function HotPolyTitle({ type, id, direction }: { type: GDFHotPollyTypes; id: number | null; direction: number | null }) {
    switch (type) {
        case GDFHotPollyTypes.airmet_turb_sfc:
            return 'Surface turbulence';
        case GDFHotPollyTypes.airmet_turb_aloft:
            return 'Turbulence aloft';
        case GDFHotPollyTypes.airmet_icing:
            return 'Icing';
        case GDFHotPollyTypes.airmet_ifr:
            return 'IFR (cig/vis)';
        case GDFHotPollyTypes.airmet_mtnobsc:
            return 'Mountain obscuration';
        case GDFHotPollyTypes.airmet_wind_sfc:
            return 'Surface wind';
        case GDFHotPollyTypes.airmet_llws:
            return 'Low level wind shear';
        case GDFHotPollyTypes.airmet_freezing:
            return 'Freezing level';
        case GDFHotPollyTypes.sigmet_turb_sfc:
            return 'Surface turbulence';
        case GDFHotPollyTypes.sigmet_turb_aloft:
            return 'Turbulence aloft';
        case GDFHotPollyTypes.sigmet_icing:
            return 'Icing';
        case GDFHotPollyTypes.sigmet_visibility:
            return 'Visibility';
        case GDFHotPollyTypes.sigmet_conv:
            return 'Convective sigmet';
        case GDFHotPollyTypes.sigmet_volcash:
            return 'Volcanic ash';
        case GDFHotPollyTypes.sigmet_blowdust:
            return 'Blowing dust';
        case GDFHotPollyTypes.sigmet_blowsand:
            return 'Blowing sand';
        case GDFHotPollyTypes.sigmet_tropcyclone:
            return 'Tropical cyclone';
        case GDFHotPollyTypes.sigmet_tstorm:
            return 'Thunderstorm';
        case GDFHotPollyTypes.sigmet_mtnobsc:
            return 'Mountain obscuration';
        case GDFHotPollyTypes.sigmet_mtnwave:
            return 'Mountain wave';
        case GDFHotPollyTypes.sigmet_llws:
            return 'Low level wind shear';
        case GDFHotPollyTypes.watch_tstorm:
            return 'Thunder Storm';
        case GDFHotPollyTypes.watch_tornado:
            return 'Tornado';
        case GDFHotPollyTypes.notam_tfr:
            return 'TFR';
        case GDFHotPollyTypes.hazard_volcash:
            return 'Volcanic ash';
        case GDFHotPollyTypes.hazard_blowdust:
            return 'Blowing dust';
        case GDFHotPollyTypes.hazard_convective:
            return 'Convective';
        case GDFHotPollyTypes.hazard_icing:
            return 'Icing';
        case GDFHotPollyTypes.hazard_turb_aloft:
            return 'Turb aloft';
        case GDFHotPollyTypes.nexrad:
            return 'NEXRAD';
        case GDFHotPollyTypes.precip:
            return 'Rainfall';
        case GDFHotPollyTypes.turbulence:
            if (id == 1) {
                return 'LGT';
            } else if (id == 2) {
                return 'LGT-MOD';
            } else if (id == 3) {
                return 'MDT';
            } else if (id == 4) {
                return 'MDT-SVR';
            } else if (id == 5) {
                return 'SVR';
            }
            return 'None';
        case GDFHotPollyTypes.icing:
            if (id == 1) {
                return 'Slight';
            } else if (id == 2) {
                return 'Moderate';
            } else if (id == 3) {
                return 'Heavy';
            }
            return 'None';
        case GDFHotPollyTypes.jetstream:
            return 'Jet stream';
        case GDFHotPollyTypes.trop_height:
            return 'Trop height';
        case GDFHotPollyTypes.trop_low:
            return 'Trop low';
        case GDFHotPollyTypes.tropical_cyclone:
            if (id == 1) {
                return 'Trop cyclone - Trop dep';
            } else if (id == 2) {
                return 'Trop cyclone - Trop storm';
            } else if (id == 3) {
                return 'Trop cyclone - Hurricane';
            }
            return 'Trop cyclone';
        case GDFHotPollyTypes.volcano:
            if (id == 0) {
                return 'Volcano- Inactive';
            } else {
                return 'Volcano- Active';
            }
        case GDFHotPollyTypes.tstorm:
            if (id == 5) {
                return 'Thunderstorm - Isolated';
            } else if (id == 10) {
                return 'Thunderstorm - Occasional';
            } else if (id !== null && id >= 15) {
                return 'Thunderstorm - Frequent';
            }
            return 'Thunderstorm';
        case GDFHotPollyTypes.route:
            return 'Route';
        case GDFHotPollyTypes.weather_front:
            return 'Front';
        case GDFHotPollyTypes.pressure_high:
            return 'Pressure - High';
        case GDFHotPollyTypes.pressure_low:
            return 'Pressure - Low';
        case GDFHotPollyTypes.turbulence_lowlevel_adv:
            return 'Turbulence - LowLevel Adv';
        case GDFHotPollyTypes.turbulence_lowlevel_obv:
            return 'Turbulence - LowLevel Obv';
        case GDFHotPollyTypes.turbulence_clearair_adv:
            return 'Turbulence - Clear Adv';
        case GDFHotPollyTypes.turbulence_clearair_obv:
            return 'Turbulence - Clear Obv';
        case GDFHotPollyTypes.turbulence_convective_adv:
            return 'Turbulence - Convect Adv';
        case GDFHotPollyTypes.turbulence_convective_obv:
            return 'Turbulence - Convect Obv';
        case GDFHotPollyTypes.turbulence_alert_adv:
            return 'Turbulence - Alert Adv';
        case GDFHotPollyTypes.turbulence_alert_obv:
            return 'Turbulence - Alert Obv';
        case GDFHotPollyTypes.turbulence_advisory_adv:
            return 'Turbulence - Advis Adv';
        case GDFHotPollyTypes.turbulence_advisory_obv:
            return 'Turbulence - Advis Obv';
        case GDFHotPollyTypes.warning_tstorm:
            return "Warning - T'Storm";
        case GDFHotPollyTypes.warning_tornado:
            return 'Warning - Tornado';
        case GDFHotPollyTypes.raim:
            switch (id) {
                case 1:
                    return 'RAIM en-route w/baro-aiding';
                case 2:
                    return 'RAIM en-route w/o baro-aiding';
                case 3:
                    return 'RAIM terminal w/baro-aiding';
                case 4:
                    return 'RAIM NPA w/baro-aiding';
                case 5:
                    return 'RAIM NPA w/baro-aiding';
                case 6:
                    return 'RAIM NPA w/o baro-aiding';
                default:
                    return;
            }
        case GDFHotPollyTypes.freeze_level:
            return 'Freezing Level';
        case GDFHotPollyTypes.sehzd_turbulence:
            return 'Hazard - Turbulence';
        case GDFHotPollyTypes.sehzd_icing:
            return 'Hazard - Icing';
        case GDFHotPollyTypes.sehzd_tstorm:
            return 'Hazard - Thunderstorm';
        case GDFHotPollyTypes.hazard_turb_advisory:
            return 'Turbulence Advisory';
        case GDFHotPollyTypes.contrail:
            // Remove after back end converted to new 4 level feed
            if (direction == 1 && id == 3) {
                id = 4;
            }
            if (id == 1) {
                return 'Contrail - Warming: Low';
            } else if (id == 2) {
                return 'Contrail - Warming: Moderate';
            } else if (id == 3) {
                return 'Contrail - Warming: High';
            } else if (id == 4) {
                return 'Contrail - Warming: Extreme';
            }
            return 'Contrail';
        case GDFHotPollyTypes.sua:
            return 'Special Use Airspace';
        case GDFHotPollyTypes.wind_field:
            return 'Tropical wind';
        case GDFHotPollyTypes.ozone:
            return 'Ozone';
        case GDFHotPollyTypes.turbulence_cat:
            return 'Turbulence CAT';
        case GDFHotPollyTypes.turbulence_edr:
            return 'Turbulence EDR';
        case GDFHotPollyTypes.sig_icing:
            return 'Icing';
        case GDFHotPollyTypes.sig_tropopause:
            return 'Tropopause';
        case GDFHotPollyTypes.probsevere:
            return 'Severe Weather probability';
        case GDFHotPollyTypes.cwa_tstorm:
            return 'Thunder storm';
        case GDFHotPollyTypes.cwa_turb:
            return 'Turbulence';
        case GDFHotPollyTypes.cwa_icing:
            return 'Icing';
        case GDFHotPollyTypes.cwa_ifr:
            return 'IFR';
        case GDFHotPollyTypes.cwa_precipitation:
            return 'Precipitation';
        case GDFHotPollyTypes.cwa_unknown:
            return 'Unknown';
    }
    return 'Unknown';
}
